import * as Services from "../../../Service/Service";
import * as Url from "../../../Service/Url";

export const GetImportHistory = async () => {
  const token = localStorage.getItem("token");
  let res = await Services.GET(Url.GET_IMPORT_HISTORY, token);
  return res;
};

export const DeleteTrackImport = async (id) => {
  const token = localStorage.getItem("token");
  let res = await Services.DELETE(Url.DELETE_IMPORT_HISTORY + id, id, token);
  return res;
};
